import { selectApp, setLanguage } from "@redux";
import { Flex } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getLiffId } from "src/Utils/getLiffId";
import getMerchant from "src/Utils/getMerchant";
import styled from "styled-components";

export const PageLogin = () => {
    const [liffId, setLiffId] = useState("");
    const [isError, setError] = useState("");
    const [merchant, setMerchant] = useState<any>();

    const dispatch = useDispatch();

    const { lang } = useSelector(selectApp);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        checkLiff();
    }, []);

    const checkLiff = async () => {
        const merchant: any = await getMerchant();
        setMerchant(merchant);

        const selectedLanguage = merchant.countrySetting.flag === "TH" ? "THAI" : "ENGLISH";
        i18n.changeLanguage(selectedLanguage);
        dispatch(setLanguage(selectedLanguage));

        const liffIdFromMerchant = getLiffId(merchant!);
        setLiffId(liffIdFromMerchant);
        if (liffIdFromMerchant === "skipLine") setError("No line integration were used");
    };

    const data: any = [];
    return (
        <>
            {isError}
            <Flex
                vertical
                justify="center"
                align="center"
                style={{ height: "100vh", width: "100%" }}
            >
                <Logo>
                    <img style={{ height: "100%" }} src={merchant?.themes?.logoSmallUrl} />
                </Logo>

                {/* {!isError && liffId && (
                    <SignInContainer>
                        <SignIn title={t("page.line_login")} liffId={liffId} />
                    </SignInContainer>
                )} */}
                <Title>{t("page.line_login_subtitle")}</Title>
            </Flex>
        </>
    );
};

const SignInContainer = styled.div`
    width: 100%;
    padding: 10px 30px;
`;

const Logo = styled.div`
    height: 100px;
    border-radius: 16px;
    overflow: hidden;
`;

const Title = styled.div`
    opacity: 0.5;
    font-weight: 400;
`;
